export function buildQuery(url: string, params: any) {
    const esc = encodeURIComponent;
    const query = Object.keys(params)
        .filter((k) => params[k])
        .map((k) => {
            if (Array.isArray(params[k])) {
                return params[k]
                    .map((value: string) => {
                        return esc(k) + '=' + esc(value);
                    })
                    .join('&');
            } else {
                return esc(k) + '=' + esc(params[k]);
            }
        })
        .filter(Boolean)
        .join('&');

    return url + '?' + query;
}
